var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 16.9987C33.6667 12.5784 31.9108 8.33919 28.7852 5.21358C25.6596 2.08798 21.4204 0.332031 17.0001 0.332031C14.8114 0.332031 12.6441 0.763127 10.622 1.60071C8.59993 2.43828 6.76261 3.66594 5.21497 5.21358C3.66733 6.76123 2.43967 8.59855 1.60209 10.6206C0.764511 12.6427 0.333416 14.81 0.333416 16.9987C0.333416 21.419 2.08936 25.6582 5.21497 28.7838C8.34058 31.9094 12.5798 33.6654 17.0001 33.6654C19.1888 33.6654 21.356 33.2343 23.3781 32.3967C25.4002 31.5591 27.2376 30.3315 28.7852 28.7838C31.9108 25.6582 33.6667 21.419 33.6667 16.9987ZM20.3334 25.332L12.0001 16.9987L20.3334 8.66536V25.332Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLeft);
export default __webpack_public_path__ + "static/media/playLeft.359455c2bcdd69d32a77740d0c895be4.svg";
export { ForwardRef as ReactComponent };